<template>
  <div class="package-detail-base">
    <div class="head-block">
      <div class="package-img-wrap" :class="{noimage: !packageInfo.package_image || packageInfo.package_image.length <= 0}" >
        <img class="package-image"
             :src="packageInfo.package_image"
             :alt="packageInfo.package_name"
             @error="onImgLoadError"
        >
      </div>
      <h1 :class="{result: isResult}">{{packageInfo.package_name}}</h1>
      <div class="package-info" v-if="!isResult">
        <span class="price" v-if="packagePrice != null">￥{{ packagePrice }}<span v-if="packagePrice > 0" class="tax-in">（税込）</span></span>
        <p class="description" v-html="packageInfo.description"></p>
        <sec-button-link
          button-face="購入する"
          :btn-disable="packageInfo.sales_invaild"
          :no-border="true"
          :link-url="`/package/${packageInfo.id}/profile`"
          :check-through="true"
        />
        <p class="attention" v-if="true">※サブスクリプションにお申込み済みの方は、サブスクリプション内で占えるものと同一のメニューになります。購入せず、ログインして画面左側「さがす」から検索してご覧ください。</p>
      </div>
    </div>
    <div class="result-list" v-if="isResult">
      <template v-for="(item, index) in menuList">
        <playlist-item
          :item-data="item"
          :key="index"
          :no-fav="true"
          :force-disable-tag-link="true"
          :scrollClass="'.result-list'"
          :scroll-tgt-is-window="true"
          @open-item="onItemClick"
        />
      </template>
    </div>
    <div class="menus-list" v-else>
      <h2>パッケージ内容</h2>
      <article v-for="(item, index) in menuList" :key="index">
        <span class="img-wrap" :class="{noimage: !item.counselor.thumbnail}"><img :src="item.counselor.thumbnail" :alt="item.counselor.name" @error="onImgLoadError" ></span>
        <h3>{{item.name}}</h3>
        <div class="menu-tags" v-if="item.tags.length > 0">
          <span class="tag-icon"><img src="/static/img/icons/ic_tag.svg"></span>
          <tag-list :tag-list="item.tags" :link-enable="false" />
        </div>
      </article>
      <div class="notice"> 備考<br>・本商品で占うことが可能な生年月日は、1940年1月1日以降の方です。<br>・一部の文章に男性向け・女性向けの表現が含まれる場合がございますが、占いの内容は性別に関係なく適応されます。</div>
    </div>
  </div>
</template>

<script>
import TagList from '@/utvStore/components/partials/TagList'
import PlaylistItem from '@/utvStore/components/Playlist/PlaylistItem'
import SecButtonLink from '@/utvStore/components/partials/SecButtonLink'
import { MENU_ITEM_TYPE } from '@/CONSTS/MENUS'
import * as type from "@/utvStore/store/mutation-types";

export default {
  name: 'PackageDetail',
  components: {SecButtonLink, TagList, PlaylistItem},
  props: {
    packageInfoReceive: {
      type: Object,
      default(){
        return {
          id: 0,
          items_id: 0,
          services_id: 0,
          package_name: '',
          caption: '',
          description: '',
          package_image: '',
          price_taxin: 0,
          menu_list: [],
        }
      }
    },
    isResult: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
    }
  },
  computed: {
    packagePrice(){
      return this.packageInfo.price_taxin != null ? this.packageInfo.price_taxin.toLocaleString() : null
    },
    packageInfo(){
      const rcv = this.packageInfoReceive
      return {
        id: rcv.id,
        items_id: rcv.items_id,
        services_id: rcv.services_id,
        package_name: rcv.package_name,
        caption: rcv.caption,
        description: rcv.description,
        package_image: rcv.package_image,
        price_taxin: rcv.price_taxin,
        sales_invaild: !(+rcv.sales_invaild === 0 || !rcv.sales_invaild || (typeof rcv.sales_invaild === 'string' && rcv.sales_invaild.toLowerCase() === 'false'))
      }
    },
    menuList(){
      const rtn = []
      const lst = this.packageInfoReceive.menu_list
      if(lst.length <= 0) return
      for(let item of lst){
        const modtg = []
        if(!!item.tags) {
          item.tags.forEach(tg => {
            modtg.push({
              id: +tg.id,
              tagName: tg.tagName,
            })
          })
        }
        const counselor = {}
        if(!!item.counselor){
          counselor.id = item.counselor.id
          counselor.name = item.counselor.name
          counselor.thumbnail = item.counselor.thumbnail
        }
        rtn.push({
          id: item.id,
          name: item.title,
          itemType: MENU_ITEM_TYPE.text,
          result: {
            text: item.text,
          },
          counselor: {...counselor},
          tags: [...modtg]
        })
      }
      return rtn
    }
  },
  methods: {
    onImgLoadError(e) {
      e.target.parentElement.classList.add('noimage')
    },
    onItemClick(val){
      this.$store.dispatch(type.SET_TEXT_DETAIL_OPEN, +val)
    },
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';
.package-detail-base {
  width: 100%;
  .head-block {
    width: 100%;
    h1 {
      color: $col_base_black;
      padding: 24px 20px 20px;
      font-size: 17px;
      line-height: 21px;
      margin: 0;
      &.result {
        border-bottom: 1px solid $col_temp_gray3;
      }
    }
    .package-img-wrap {
      width: 100%;
      &.noimage {
        display: none;
      }
      img {
        width: 100%;
        height: auto;
        display: block;
      }
    }
    .package-info {
      width: 100%;
      padding: 0 20px;
      margin-bottom: 17px;
      .price {
        color: #ed1e79;
        font-size: 18px;
        display: block;
        width: 100%;
        text-align: right;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 20px;
        .tax-in {
          font-size: 10px;
          margin-left: -2px;
          display: inline-block;
          padding-bottom: 2px;
          vertical-align: bottom;
        }
      }
      .description {
        border-top: 1px solid $col_temp_gray3;
        color: $col_temp_gray6;
        padding-top: 25px;
        margin: 0 0 15px;
        font-size: 13px;
        line-height: 21px;
      }
      .attention {
        margin: 0 0 4px;
        font-size: 11px;
        color: $col_base_black;
      }
      /deep/ .button-link-base {
        width: 100%;
        padding: 0 10px 10px;
        .button-link {
          width: 100%;
        }
      }
    }
  }
  .menus-list {
    h2 {
      color: $col_base_black;
      font-size: 12px;
      font-weight: bold;
      width: 100%;
      margin: 0;
      padding: 10px 8px 10px 20px;
      line-height: 1;
      background: linear-gradient(86.53deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
    }
    .notice {
      font-size: 13px;
      line-height: 21px;
      padding: 25px 20px 70px;
      color: $col_base_black;
    }
    article {
      $imageW: 55px;
      width: 100%;
      padding: 24px 20px 20px $imageW + 20px + 15px;
      border-bottom: 1px solid $col_temp_gray3;
      position: relative;
      min-height: 100px;
      .img-wrap {
        width: $imageW;
        height: $imageW;
        border-radius: $imageW;
        overflow: hidden;
        position: absolute;
        top: 24px;
        left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $col_lite_gradient;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        &.noimage {
          & > img {
            visibility: hidden;
          }
          &::after {
            content: 'NO IMAGE';
            text-align: center;
            position: absolute;
            line-height: 1;
            transform: scale(0.8);
            font-size: 10px;
            color: $col_temp_key1;
            background: $col_lite_gradient;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
      h3 {
        color: $col_base_black;
        margin: 0 0 4px;
        font-size: 17px;
        line-height: 19px;
      }
      .menu-tags {
        display: block;
        padding-left: 18px;
        position: relative;
        margin-bottom: 14px;

        .tag-icon {
          display: inline-block;
          position: absolute;
          top: 3px;
          left: 0;
          width: 13px;

          img {
            display: block;
            width: 100%;
          }
        }

        /deep/ .tag-list-base {
          color: $col_normal_font;
          padding: 3px 0 0;
          line-height: 10px;
        }
      }

    }
  }
  .result-list {
    padding-bottom: 300px;
    /deep/ .tag-list-base {
      color: $col_normal_font;
      padding: 3px 0 0;
      line-height: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Package/PackageDetail.vue